import { MutuoSeleccionado } from "../models/MutuoSeleccionado";
import { columns } from "../../../dtos/columns";
import { format } from "rut.js";

const mapEstadoTexto = (estado?: string) => {
    if (estado === 'exitoso') return 'Exitoso';
    if (estado === 'fallido') return 'Fallido';
    if (estado === 'procesando') return 'Procesando';
    return 'Pendiente';
};

export function useColumnsResultsExcel() {

    const COLUMNSEXCEL: columns<MutuoSeleccionado>[] = [
        {
            name: 'N° Solicitud',
            selector: (row: MutuoSeleccionado) => row.numeroSolicitud,
            sortable: true,
            sortField: 'numeroSolicitud',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Tipo mutuo',
            selector: (row: MutuoSeleccionado) => row.tipoMutuo,
            sortable: true,
            sortField: 'tipoMutuo',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Nombre o razón social',
            selector: (row: MutuoSeleccionado) => row.nombre,
            sortable: true,
            sortField: 'nombre',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'RUT',
            selector: (row: MutuoSeleccionado) => format(row.rut!),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Estado',
            selector: (row: MutuoSeleccionado) => mapEstadoTexto(row.estadoActivacion),
            sortable: true,
            sortField: 'estadoActivacion',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Observaciones',
            selector: (row: MutuoSeleccionado) => row.observacion,
            sortable: true,
            sortField: 'observacion',
            wrap: true,
            alling: 'left',
            export: true,
        }
    ]

    return { COLUMNSEXCEL };
}